export enum SortItemKey {
    default_sort = 'default_sort',
    position_value_sort = 'position_value_sort',
    alphabetically_sort = 'alphabetically_sort',
    profit_loss_usdt_sort = 'profit_loss_usdt_sort',
    profit_loss_usd_value = 'profit_loss_usd_value',
    profit_loss_usd_price = 'profit_loss_usd_price'
}

export const SortItemDefaultValue = {
    [SortItemKey.default_sort]: 'Default',
    [SortItemKey.position_value_sort]: 'Position value: high to low',
    [SortItemKey.alphabetically_sort]: 'Coin: A to Z',
    [SortItemKey.profit_loss_usdt_sort]: 'Profit loss: usdt',
    [SortItemKey.profit_loss_usd_value]: 'Profit loss: usdt',
    [SortItemKey.profit_loss_usd_price]: 'Profit loss: usdt',
}
export const ProfitLossSortText = {
    'USDT':SortItemKey.profit_loss_usdt_sort,
    'BTC': SortItemKey.profit_loss_usdt_sort,
    'USDC': SortItemKey.profit_loss_usdt_sort,
    'SUSDT':SortItemKey.profit_loss_usdt_sort,
    'SBTC':SortItemKey.profit_loss_usdt_sort,
    'SUSDC':SortItemKey.profit_loss_usdt_sort,
}